import { useCallback } from 'react'

import { useUpdateAssetMutation } from '~generated/hooks'
import { UpdateAssetInput } from '~generated/types'

export default function useUpdateAsset() {
  const [mutation, options] = useUpdateAssetMutation()

  const update = useCallback(
    (input: UpdateAssetInput) => {
      mutation({
        variables: {
          input,
        },
      })
    },
    [mutation]
  )

  return [update, options] as const
}
